import { Link } from '@remix-run/react'
import { ChevronRightIcon } from '../icons'
import { Button } from '~/components/general/Button'

type ErrorComponentProps = {
  isRouteError: boolean
}

export const ErrorComponent = ({ isRouteError }: ErrorComponentProps) => {
  const title = isRouteError
    ? "Sorry, the page you were looking for doesn't exist"
    : 'Something went wrong on our side. Please try again later.'

  return (
    <div className="flex flex-col lg:mx-40 mt-12 lg:max-w-5xl xl:mx-auto xl:max-w-7xl">
      <div className="flex flex-row max-lg:flex-col-reverse mt-12 gap-4">
        <div className="flex flex-col gap-6 lg:w-1/2 mb-auto">
          <h1 className="title lg:text-5xl lg:text-left text-xl">{title}</h1>
          <div className="flex gap-8 max-lg:justify-center">
            <Button
              text={'Create a Resume'}
              type={'link'}
              href={'/app/create-resume'}
              target={'_self'}
            />
            <Button
              text={'Go to Homepage'}
              type={'link'}
              href={'/'}
              color={'lightBlue'}
              target={'_self'}
            />
          </div>
        </div>
        <div className="mx-auto lg:w-1/2">
          <img src="/images/ErrorComponent/error.svg" alt="Error" />
        </div>
      </div>
      <div className="flex max-lg:flex-col gap-4 lg:gap-8 mt-12">
        <div className="bg-blue-10 p-4 rounded-3xl flex-1">
          <h4 className="text-desktop-m">Build your Cover letter with</h4>
          <div className="flex gap-2">
            <img src="/icons/error/resumes.svg" />
            <Link
              className="text-blue-50 text-desktop-m"
              to="/cover-letter-builder"
              target="_blank"
            >
              Cover letter Builder
            </Link>
          </div>
          <div className="flex justify-end">
            <Link
              to="/cover-letter-builder"
              className="bg-white rounded-full w-12 h-12 flex justify-center"
            >
              <ChevronRightIcon className="self-center" />
            </Link>
          </div>
        </div>
        <div className="bg-[#F1F2FF] p-4 rounded-3xl flex-1">
          <h4 className="text-desktop-m">Plan your path to success with</h4>
          <div className="flex gap-2">
            <img src="/icons/error/pathway.svg" />
            <Link to="/career-pathways" className="text-indigo-50 text-desktop-m" target="_blank">
              Career Pathways
            </Link>
          </div>
          <div className="flex justify-end">
            <Link
              to="/career-pathways"
              className="bg-white rounded-full w-12 h-12 flex justify-center"
            >
              <ChevronRightIcon className="self-center" />
            </Link>
          </div>
        </div>
      </div>
      <div className="flex justify-center lg:mt-8 mt-2">
        <span className="text-desktop-s text-neutral-50 max-lg:text-center">
          Got any questions or just want to say hi to the team{' - '}
          <Link to="/contact" className="text-blue-50">
            {' Contact us'}
          </Link>
        </span>
      </div>
    </div>
  )
}
